"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WriteOffRecordList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var coupon_1 = require("../../model/coupon");
var service_1 = require("../../../library/base/service");
var WriteOffRecordList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(WriteOffRecordList, _super);
    function WriteOffRecordList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '核销记录';
        _this.code = '300001';
        _this.desc = '核销记录';
        _this.requestParams = new coupon_1.WriteOffRecordListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return WriteOffRecordList;
}(service_1.BaseService));
exports.WriteOffRecordList = WriteOffRecordList;
//# sourceMappingURL=writeOffRecordList.js.map